import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const imageCarouselFn = /* @__PURE__ */ createRecipe('image-carousel', {}, [])

const imageCarouselVariantMap = {}

const imageCarouselVariantKeys = Object.keys(imageCarouselVariantMap)

export const imageCarousel = /* @__PURE__ */ Object.assign(memo(imageCarouselFn.recipeFn), {
  __recipe__: true,
  __name__: 'imageCarousel',
  __getCompoundVariantCss__: imageCarouselFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: imageCarouselVariantKeys,
  variantMap: imageCarouselVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, imageCarouselVariantKeys)
  },
  getVariantProps: imageCarouselFn.getVariantProps,
})